import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, OnDestroy, AfterViewInit, Output,EventEmitter} from '@angular/core';
import { AuthorizationPipe } from '../../common/pipes/authorization.pipe';
import { Permission } from '../../common/enums/permission.enum';
import { CommonService } from '../../shared/services/common.service';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { CommonMessage } from '../common/common-messages';
import { MessageService } from '../../shared/services/message.service';
import { CookieService } from 'ngx-cookie-service';
import { Constants, MemberType, IsoCodeThree } from '../common/constants';
import { DataShareService } from '../../shared/services/data.service';
import { TicketsComponent } from './tickets.component';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { AutoshipMemberInfo } from '../interface/autoship-memberinfo';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { MemberNotesComponent } from './member-notes.component';
import { environment } from '../../../environments/environment';
import { MemberActivityLogComponent } from './member-activity-logs.component';
import { Tabber } from '../enums/tabber';
import { MemberEmailInfo } from '../interface/member-email-info.interface';
import { MemberEmailViewTab } from '../interface/member-email-view-tab.interface';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { DownlineMapComponent } from './downline-map.component';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MasterReportsComponent } from './master-reports.component';
import { TabConstants } from '../constants/tab.constants';
import { TabsetComponent } from 'ngx-bootstrap/tabs/tabset.component';
import { CustomerService } from '../services/customer.service';
import { CartTypes } from '../enums/cart-type.enum';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { Country } from '../../shared/interface/country.interface';
import { Cart } from '../models/cart.model';
import { CacheService } from '../../shared/services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { OrderHistoryComponent } from './orderhistory.component';
import { MemberEmailLogComponent } from './member-email-log.component';
import { MemberDocumentsComponent } from './member-documents.component';
import { SSO } from '../../sso/sso.constants';

@Component({
    selector: 'fbodetail-dashboard',
    templateUrl: '../templates/template1/views/fbodetail.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/profile-info.less'
    ],
    providers: [AuthorizationPipe]
})
export class FBODetailComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

    @Input() fboinputvalue: any;
    @Input() orderNumber?: string;
    @Input() webOrderNumber?: string;
    @Input() country?: string;
    @Input() isNewOrder: number;
    @Input() memberType: string;
    @Input() orderType: string;
    @Input() count: number;
    fboid: string;
    showCreateTicketTab: boolean;
    @ViewChild(TicketsComponent) ticketsComponent: TicketsComponent;
    @ViewChild(DownlineMapComponent) downlineMapComponent: DownlineMapComponent;
    @ViewChild(MasterReportsComponent) MasterReportsComponent: MasterReportsComponent;
    @ViewChild(MemberDocumentsComponent) MemberDocumentsComponent: MemberDocumentsComponent;
    @ViewChild(MemberNotesComponent) membersComponent: MemberNotesComponent;
    @ViewChild(MemberActivityLogComponent) memberActivityLogComponent: MemberActivityLogComponent;
    @ViewChild('staticTabs') staticTabs: TabsetComponent;
    @ViewChild(OrderHistoryComponent) orderHistoryComponet: OrderHistoryComponent;
    @ViewChild(MemberEmailLogComponent) memberEmailLogComponent: MemberEmailLogComponent;

    id: any;
    isDisputeTicket: boolean;
    ticketId: any;
    isView: any;
    tabTitle: string;
    homeCountry: string;
    componentName: any;
    tabModel: ViewTabModel;
    tabs: any[] = new Array<ViewTabModel>();
    existedValues: ViewTabModel[] = new Array<ViewTabModel>();
    deleteModal: DeleteModal;
    justifyingTabs = false;
    showAutoShip = false;
    showPaymentMethods = false;
    showDownline = false;
    webOrderId: string;
    distributorInfo: DistributorInfo;
    memberId: string;
    autoshipTabInfo: AutoshipMemberInfo;
    homeCountryInfo: string;
    operatingCountryInfo: string;
    isDistributor = false;
    isFBO = false;
    isFPC = false;
    orderHistoryTabs: OrderInfoTab[] = new Array<OrderInfoTab>();
    activetab: number;
    emailMessageId: number;
    sendTo: string;

    memberEmailInfo: MemberEmailInfo;
    ticketTabs: TicketTabInfo[] = new Array<TicketTabInfo>();
    isMemberAttachments: boolean;
    FBODetailPermissions: any[] = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
    Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
    Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW,
    Permission.MANAGE_TICKETS_VIEW,
    Permission.MANAGE_TICKETS_CREATE, Permission.MEMBER_NOTES_VIEW, Permission.MEMBER_ACTIVITY_LOG_VIEW];

    memberEmailViewTabSubscription: Subscription;
    memberEmailViewTabs: MemberEmailViewTab[] = new Array<MemberEmailViewTab>();
    customerServiceAccessLevelId: number = AccessLevel.Customer_Service;
    shoppingCartCount = 0;
    memberCartSessionFallBackCount = 0;
    titanEnabledCountries: Country[];
    shoppingCart: Cart;
    viewShoppingBagPermission: boolean;
    isGuest = false;
    storeInfo: StoreConfig;
    savedBagCountry: number;
    tabber: any = Tabber;
    memberDocument:boolean;
    cookieService: CookieService = new CookieService(document);
    @Output() closeTabForFboID = new EventEmitter<string>();

    constructor(private _commonService: CommonService, private _dataShareService: DataShareService, private _cacheService: CacheService,
        private messageService: MessageService, private _translatePipe: TranslateService, private _customerservice: CustomerService) { }

    ngOnInit(): void {
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'fbo-detail-page';
        }
        this.tabModel = new ViewTabModel();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.subscribeTabs();
        // if(!this.isNewOrder && this.isNewOrder === false){
        this.subscribeOrderHistoryTab();
        // }
        
        const isFboProfile = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[0] + ']'), AccessLevel.Customer_Service);
        const isFboOrder = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[1] + ']'), AccessLevel.Customer_Service);
        const isFboAutoship = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[2] + ']'), AccessLevel.Customer_Service);
        const isFboPayment = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[3] + ']'), AccessLevel.Customer_Service);
        const isFboDownline = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[4] + ']'), AccessLevel.Customer_Service);
        const isFboReports = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[5] + ']'), AccessLevel.Customer_Service);
        const isFboTickets = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[6] + ']'), AccessLevel.Customer_Service);
        const isFboTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[7] + ']'), AccessLevel.Customer_Service);
        const isMemberAttachments = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[8] + ']'), AccessLevel.Customer_Service);
        const isMemberActivityLog = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[9] + ']'), AccessLevel.Customer_Service);

        // Based on permissions updating active tab
        this.activetab = isFboProfile ? Tabber.FBOProfile : (isFboOrder ? Tabber.OrderHistory : (isFboAutoship ? Tabber.Autoship : (isFboPayment ? Tabber.PaymentMethods : (isFboDownline ? Tabber.Downline : (isFboReports ? Tabber.Tab6 : (isFboTickets ? Tabber.Tickets : (isMemberAttachments ? Tabber.Notes : (isMemberActivityLog ? Tabber.ActivityLog : Tabber.FBOProfile))))))));

        // this.route.params.subscribe((params: Params) => {
        //     this.fboid = params["id"];
        // });
        this.fboid = this.fboinputvalue;
        if (isFboOrder && this.country && (this.orderNumber || this.webOrderNumber || this.isNewOrder)) {
            const orderInfo = new OrderInfoTab();
            orderInfo.distributorID = this.fboinputvalue;
            orderInfo.homeCountry = this.country;
            orderInfo.orderID = !this.isNewOrder ? this.orderNumber : '';
            orderInfo.webOrderID = this.webOrderNumber;
            const isFromTitan = this.isNewOrder;
            if (isFromTitan) {
                orderInfo.recentOrder = true;
            } else {
                orderInfo.recentOrder = false;
            }

            this.addToOrderViewList(orderInfo);
        }
        this.subscribeTicketTabClose();
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.subscribeMemberEmailViewTab();
        this.getAllCountriesInfo();
        this.viewShoppingBagPermission = this._commonService
            .checkPermissionByAccessLevel(JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        }

    ngOnChanges(changes: SimpleChanges) {
        const isFboOrder = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBODetailPermissions[1] + ']'), AccessLevel.Customer_Service);
        this.orderNumber = changes['orderNumber'] ? changes['orderNumber'].currentValue : this.orderNumber;
        this.webOrderNumber = changes['webOrderNumber'] ? changes['webOrderNumber'].currentValue : this.webOrderNumber;
        this.country = changes['country'] ? changes['country'].currentValue : this.country;
        this.isNewOrder = changes['isNewOrder'] ? changes['isNewOrder'].currentValue : this.isNewOrder;
        if (isFboOrder  && this.country && (this.webOrderNumber || this.orderNumber || this.isNewOrder)) {
            const orderInfo = new OrderInfoTab();
            orderInfo.distributorID = this.fboinputvalue;
            orderInfo.homeCountry = this.country;
            orderInfo.orderID = !this.isNewOrder ? this.orderNumber : '';
            orderInfo.orderNumber = this.orderNumber;
            orderInfo.webOrderID = this.webOrderNumber;
            if (this.isNewOrder) {
                orderInfo.recentOrder = true;
            } else {
                orderInfo.recentOrder = false;
            }
            this.addToOrderViewList(orderInfo);
        }
    }

    ngAfterViewInit(): void {
        // Move page to top
        window.scrollTo(0, 0);
    }
    /**
     * @description
     * @date 2019-07-15
     * @memberof MemberEmailViewTabComponent
     */
    subscribeMemberEmailViewTab(): void {
        this.memberEmailViewTabSubscription = this.messageService.getMemberEmailViewTab()
            .subscribe((memberEmailInfo: MemberEmailInfo) => {
                if (memberEmailInfo && memberEmailInfo.distributorInfo
                     && memberEmailInfo.distributorInfo.distributorId === this.fboinputvalue) {
                    this.addMemberEmailViewTab(memberEmailInfo);
                }
            });
    }

    getMemberDetails(){
        this._customerservice.getMemberDetails(this.fboid).subscribe((response) => 
        {
            const memberDoc = response.memberDocuments[0] ? true : false;
            if(memberDoc){
                this.memberDocument = true;
            }else{
                this.memberDocument = false;
            }
           
            
        });
    }

    /**
     * @description
     * @date 2019-07-15
     * @param {MemberEmailViewTab} memberEmailViewTab
     * @memberof MemberEmailViewTabComponent
     */
    addMemberEmailViewTab(memberEmailInfo: MemberEmailInfo): void {
        this.memberEmailViewTabs = [];
        const memberEmailTab = this.memberEmailViewTabs.find(x => x.tabId === memberEmailInfo.memberEmailLog.id);
        const title = this._translatePipe.get('customer-service.Sent Email')['value'];
        if (!memberEmailTab) {
            const memberEmailViewTab: MemberEmailViewTab = {
                componentName: 'memberEmailViewTab',
                title: title,
                tabId: memberEmailInfo.memberEmailLog.id,
                active: true,
                memberEmailInfo: memberEmailInfo,
                disabled: false,
                removable: true,
                closeNewEmailViewTab: false
            };
            this.memberEmailViewTabs.push(memberEmailViewTab);
            this.alignTabs();
        } else {
            this.memberEmailViewTabs.forEach(x => {
                if (x.tabId === memberEmailInfo.memberEmailLog.id) {
                    x.active = true;
                } else {
                    x.active = false;
                }
            });
        }

    }

    /**
     * @description
     * @date 2019-07-15
     * @param {MemberEmailViewTab} tab
     * @memberof MemberEmailViewTabComponent
     */
    removeMemberEmailViewTab(tab: MemberEmailViewTab): void {
        if (this.memberEmailViewTabs) {
            this.memberEmailViewTabs.splice(this.memberEmailViewTabs.indexOf(tab), 1);
            this.alignTabs();
            // Tab behavior
            this.activetab = 10;
            const tabIndex = this.staticTabs.tabs.findIndex(item => item.id === TabConstants.MEMBER_EMAIL);
            this.staticTabs.tabs[tabIndex].active = true;
        }
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof FBODetailComponent
     */
    createTicket(): void {
        this.activetab = Tabber.Notes;
        this.showCreateTicketTab = true;
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof FBODetailComponent
     */
    activeTicketTab(): void {
        this.activetab = Tabber.Tickets;
        this.selectTab(Tabber.Tickets);
    }

    /**
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof FBODetailComponent
     */
    selectTab(tab: any) {
        this.activetab = tab;
        if (tab === Tabber.Tickets && this.ticketsComponent) {
            this.ticketsComponent.ngOnInit();
        }
        if (tab === Tabber.Reports && this.downlineMapComponent) {
            
            this.downlineMapComponent.ngOnInit();
        }
        if (tab === Tabber.OrderHistory || tab === Tabber.FBOProfile) {
            if (this._cacheService.get(CacheKey.CARTUPDATED)) {
                this.shoppingCartCount = 0;
                this.memberCartSessionFallBackCount = 0;
                this.savedBagCountry = null;
                this.getStoreInfo();
                this._cacheService.remove(CacheKey.CARTUPDATED);
            }
            if (tab === Tabber.OrderHistory && this.orderHistoryComponet) {
                if (this._cacheService.get(CacheKey.ORDERTABREFRESH))  {
                    this.orderHistoryComponet.getRecentOrders();
                    this._cacheService.remove(CacheKey.ORDERTABREFRESH);
              }
            }
        }
        if (tab === Tabber.Emails && this.memberEmailLogComponent) {
            this.memberEmailLogComponent.emailLogSearch();
        }
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof FBODetailComponent
     */
    activeNotesTab(): void {

        this.activetab = Tabber.Notes;
        this.selectTab(Tabber.Notes);
    }

    changeTab(tab: any) {
        this.activetab = tab;
    }
    subscribeTabContent() {
        this.messageService.getCustomerServiceUserTabContent().subscribe((data: TicketTabInfo) => {
            this.addToTicketTabs(data);
        });
    }
    addToTicketTabs(data: TicketTabInfo) {
        if ((this.ticketTabs.length + this.orderHistoryTabs.length) < Constants.MaximumTablsTicketOrderLength) {
            if (data && data.distributorID === this.fboinputvalue) {
                this.activetab = 0;
                this.orderHistoryTabs.forEach((tab: OrderInfoTab) => tab.active = false);
                this.ticketTabs.forEach((tab: TicketTabInfo) => tab.active = false);
                const ticketTab = this.ticketTabs.find((tab: TicketTabInfo) => tab.ticketID === data.ticketID);
                if (data.editTicket) {
                    this.removeTicketTab(ticketTab);
                }
                if (data.viewTicket && ticketTab && ticketTab.viewTicket) {
                    this.ticketTabs.forEach((tab: TicketTabInfo) => { if (tab.ticketID === data.ticketID && tab.viewTicket === true) { tab.active = true; } });
                } else {
                    data.active = true;
                    data.disabled = false;
                    data.removable = true;
                    this.ticketTabs.push(data);
                    this.alignTabs();
                }
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
            }
        } else {
            this.displayAlertBoxOnReachingMaxTabs();
        }
    }

    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
    */
    subscribeClosedTabs() {
        this.messageService.getCloseTabsEvent().subscribe((data: any) => {
            if (data) {
                this.closeAllOpenedTabs();
            }
        });
    }
    closeTab(tabName: string) {
        if (tabName === 'Autoship') {
            this.showAutoShip = false;
        } else if (tabName === 'PaymentMethods') {
            this.showPaymentMethods = false;
        } else if (tabName === 'Downline') {
            this.showDownline = false;
        }
        this.selectTab(1);
    }
    subscribeTabs() {
        this.messageService.getTabs().subscribe((tab: any) => {
            if (tab && tab.fboId === this.fboid) {
                if (tab.tabName === 'Autoship') {
                    this.showAutoShip = true;
                    this.selectTab(Tabber.Autoship);
                } else if (tab.tabName === 'PaymentMethods') {
                    this.showPaymentMethods = true;
                    this.selectTab(Tabber.PaymentMethods);
                } else if (tab.tabName === 'Downline') {
                    this.showDownline = true;
                    this.selectTab(Tabber.Downline);
                }
            }
        });
    }
    addNewTab(): void {
        const newTabIndex = this.tabs.length + 1;
        this.tabModel = new ViewTabModel();
        this.id = this.tabs.length !== 0 ? this.tabs[this.tabs.length - 1].id + 1 : newTabIndex;
        this.tabModel.id = this.id;
        this.tabModel.ticketId = this.ticketId;
        this.tabModel.isView = this.isView;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.activetab = 0;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array<ViewTabModel>();
        const tabOpen: ViewTabModel = this.tabs.find(tab => tab.ticketId && tab.ticketId === this.ticketId);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            // this.tabs.splice(0, 1);
            this.displayAlertBoxOnReachingMaxTabs();
        } else {
            if (!tabOpen) {
                this.tabs.push(this.tabModel);
            } else {
                const selectedId = tabOpen.id;
                this.tabs.forEach(function (x: ViewTabModel) {
                    if (x.id !== selectedId) {
                        x.active = false;
                    } else {
                        x.active = true;
                    }
                });
            }
        }
    }
    /**
     * removes tab at specific index
     * @param tab
     */
    removeTabHandler(tab: any): void {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        }
    }

    /**
     * Close all opened tabs
     */
    closeAllOpenedTabs() {
        this.tabs = []; // new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        // this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
    }

    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    displayAlertBoxOnReachingMaxTabs() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsTicketOrderMessage;
    }

    getDistributorInfo(distributorDetails: any) {
        this.distributorInfo = distributorDetails && !!Object.keys(distributorDetails).length ? {...distributorDetails} : distributorDetails;
        this.setDistributorFlag(distributorDetails.memberTypeId);
        this.setFBOFlag(this.memberType);
        this.getMemberDetails();
    }

    setDistributorFlag(memberTypeId: number): void {
        if (memberTypeId === MemberTypeEnum.DISTRIBUTOR) {
            this.isDistributor = true;
        }
    }

    setFBOFlag(memberType: string): void {
        if (memberType === MemberType.FOB) {
            this.isFBO = true;
        }
        if(memberType === MemberType.PREFERREDCUSTOMER || memberType === MemberType.FPC || memberType === MemberType.PREFERRED_CUSTOMER){
            this.isFPC = true;
        }
        if (memberType === MemberType.GUEST || this.distributorInfo.memberType === MemberType.GUEST) {
            this.isGuest = true;
        }
    }

    getAutoshipTabInfo(autoshipTabInfo: any) {
        this.autoshipTabInfo = autoshipTabInfo;
    }
    getHomeCountryInfo(homeCountryInfo: any) {
        this.homeCountryInfo = homeCountryInfo;
        this.memberCartSessionFallBackCount = 0;
        this.shoppingCartCount = 0;
        this.getStoreInfo();
    }

    getOperatingCountryInfo(operatingCountryInfo: any) {
        this.operatingCountryInfo = operatingCountryInfo;
    }

    /**
     * set member Id for Autoships tab
     */
    setMemberId(memberId: any) {
        this.memberId = memberId;
    }
    addToOrderViewList(data: OrderInfoTab) {
        if ((this.ticketTabs.length + this.orderHistoryTabs.length) < Constants.MaximumTablsTicketOrderLength) {
            const tab: OrderInfoTab = this.orderHistoryTabs.find((tab: OrderInfoTab) => (tab.webOrderID && tab.webOrderID === data.webOrderID || (tab.orderID && data.orderID && tab.orderID === data.orderID)) );
            tab ? '' : this.orderHistoryTabs.find((tab: OrderInfoTab) => tab.newOrder === true);
            this.orderHistoryTabs.forEach((orderTab: OrderInfoTab) => orderTab.active = false);
            if (tab) {
                this.activetab = 0;
                tab.active = true;
            } else {
                const orderInfo = new OrderInfoTab();
                if (!data.newOrder) {
                    orderInfo.distributorID = data.distributorID;
                    orderInfo.homeCountry = data.homeCountry;
                    orderInfo.orderID = data.orderID;
                    orderInfo.orderNumber = data.orderNumber;
                    orderInfo.webOrderID = data.webOrderID;
                    orderInfo.retailID = data.retailID;
                    if (data.webOrderID) {
                        orderInfo.title = data.webOrderID; // "Order - " +
                    } else if (data.orderID) {
                        orderInfo.title = data.orderID; // "Order - " +
                    } else {
                        orderInfo.title = data.orderNumber; // "Order - " +
                    }
                    orderInfo.componentName = 'orderViewTab';
                    orderInfo.recentOrder = data.recentOrder;
                    // orderInfo.newOrder = this.isNewOrder === true ? false:true;
                } else {
                    orderInfo.title = 'Create Order';
                    orderInfo.newOrder = true;
                }
                orderInfo.active = true;
                this.activetab = 0;
                orderInfo.disabled = false;
                orderInfo.removable = true;
                this.orderHistoryTabs.push(orderInfo);
                this.alignTabs();
            }
            // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
            this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
        } else {
            this.displayAlertBoxOnReachingMaxTabs();
        }
    }
    subscribeOrderHistoryTab() {
        this.messageService.getOrderHistoryTab().subscribe((data: OrderInfoTab) => {
            if (data && data.distributorID === this.fboinputvalue) {
                if (!data.closeNewOrderTab) {
                    this.addToOrderViewList(data);
                } else {
                    const tab: OrderInfoTab = this.orderHistoryTabs.find((tab: OrderInfoTab) => tab.newOrder === true);
                    const orderInfo = new OrderInfoTab();
                    orderInfo.componentName = 'orderViewTab';
                    orderInfo.webOrderID = data.webOrderID;
                    orderInfo.distributorID = data.distributorID;
                    orderInfo.orderID = data.orderID;
                    orderInfo.title = 'Order - ' + data.webOrderID;
                    orderInfo.recentOrder = true;
                    orderInfo.active = true;
                    this.activetab = 0;
                    orderInfo.disabled = false;
                    orderInfo.removable = true;
                    orderInfo.homeCountry = data.homeCountry;
                    this.orderHistoryTabs.push(orderInfo);
                    this.alignTabs();
                    this.removeOrderTab(tab);
                }
            }
        });
    }
    /**
     * removes orders tab at specific index
     * @param tab
     */
    removeOrderTab(tab: any): void {
        if (this.orderHistoryTabs) {
            this.orderHistoryTabs.splice(this.orderHistoryTabs.indexOf(tab), 1);
            this.alignTabs();
            // Tab behavior
            this.activetab = 2;
            const tabIndex = this.staticTabs.tabs.findIndex(item => item.id === TabConstants.ORDER_HISTORY);
            this.staticTabs.tabs[tabIndex].active = true;
        }
    }
    /**
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof FBODetailComponent
     */
    removeTicketTab(tab: any) {
        if (this.ticketTabs) {
            this.ticketTabs.splice(this.ticketTabs.indexOf(tab), 1);
            this.alignTabs();
            // Tab behavior
            this.activetab = 7;
            if (this.subscribeTabs && this.staticTabs.tabs && this.staticTabs.tabs.length > 0) {
            const tabIndex = this.staticTabs.tabs.findIndex(item => item.id === TabConstants.CUSTOMER_TICKET);
            this.staticTabs.tabs[tabIndex].active = true;
            }
        }
    }
    subscribeTicketTabClose() {
        this.messageService.getClosingTabInfo().subscribe((data: any) => {
            if (data && (data.distributorID === this.fboinputvalue)) {
                this.ticketTabs.forEach((tickeTab: TicketTabInfo) => tickeTab.active = false);
                if (this.ticketTabs.length > 0) {
                    const tab = this.ticketTabs[data.tabIndex];
                    this.removeTicketTab(tab);
                    this.alignTabs();
                }
                if (!data.modifiedDistributor) {
                    this.goToTicketView(data.ticketID, data.ticketNumber);
                } else {
                    this.selectTab(1);
                }
            }
        });
    }
    /**
    * Navigate to ticket view tab
    */
    goToTicketView(ticketId: number, ticketNumber: string) {
        const ticketTab = new TicketTabInfo();
        ticketTab.distributorID = this.fboid;
        ticketTab.isNewTicket = false;
        ticketTab.ticketID = ticketId;
        ticketTab.title = 'View Ticket - ' + ticketNumber;
        ticketTab.viewTicket = true;
        this.addToTicketTabs(ticketTab);
    }
    /**
    * on clicking of "No" this method will be called.
    */
    doNotRemoveFormData() {
        // data should not be removed...
    }

    ngOnDestroy(): void {
        if (this.memberEmailViewTabSubscription) {
            this.memberEmailViewTabSubscription.unsubscribe();
        }
    }
/**
 * @description To align tab content top
 * @date 2020-01-29
 * @memberof FBODetailComponent
 */
alignTabs(): void {
        setTimeout(() => {
            const element: any = document.querySelector('.active .cs-secondary-tabs.nav  > .nav-tabs');
            const tabContentElement: any = document.querySelector('.active .cs-secondary-tabs.nav > .tab-content');
            if (element && tabContentElement) {
                const tabsHeight = element.offsetHeight;
                tabContentElement.style.marginTop = (tabsHeight + 3) + 'px';
            }
        }, 100);
    }


    /**
     * @description get store info
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    getStoreInfo() {
        if (this.homeCountryInfo) {
        this._customerservice.getStoreInfoFromConfig(this.homeCountryInfo)
            .subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    if (this.distributorInfo) {
                    this.distributorInfo = {...this.distributorInfo,displayMiddleName : this.storeInfo.displayMiddleName};
                    }
                    this.getMemberCart(this.storeInfo);
                }
            },err => {
                this.getMemberCartFallBack();
            });
        }
    }


    /**
     * @description get members cart count and cart
     * @date 2020-04-03
     * @param {StoreConfig} storeInfo
     * @memberof FBODetailComponent
     */
    getMemberCart(storeInfo: StoreConfig) {
        this._customerservice.getCartItemsByMemberIdAndCartType(this.distributorInfo.memberId,
            CartTypes.OrderCart, storeInfo).subscribe((response) => {
                if (response && response.sessionGuid && response.items && response.items.length) {
                    this.shoppingCart = response;
                    this.shoppingCartCount = 0;
                    response.items.forEach(item => {
                        this.shoppingCartCount += item.quantity;
                    });
                   
                } else {
                    this.getMemberCartFallBack();
                }
            }, error => {
                new Error(error);
            });
    }


    /**
     * @description fallback for non-titan home country members
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    getMemberCartFallBack(): void {
        const countries = this.titanEnabledCountries.filter(item =>
            item.isocodeThree.toUpperCase() !== this.homeCountryInfo.toUpperCase());
        if (countries && countries.length && this.memberCartSessionFallBackCount < countries.length) {
            const fallbackCountry = countries[this.memberCartSessionFallBackCount];
            this.savedBagCountry = fallbackCountry.countryId;
            this._customerservice.getStoreInfoFromConfig(fallbackCountry.isocodeThree)
                .subscribe(response => {
                    if (response) {
                        this.getMemberCart(response);
                        this.memberCartSessionFallBackCount++;
                    }
                });
        }
    }


    /**
     * @description get all titan countries
     * @date 2020-04-03
     * @memberof FBODetailComponent
     */
    getAllCountriesInfo() {
        this._customerservice.getAllCountries(true).subscribe(response => {

            if (response) {
                this.titanEnabledCountries = response.filter(country => country.isocodeThree
                    === IsoCodeThree.USA || country.isocodeThree === IsoCodeThree.CAN);
            }
        });
    }

    
      /**
       * @description cache the shopping cart to open new tab
       * @date 2020-04-03
       * @memberof FBODetailComponent
       */
      gotoCheckout(): void {
        if (this.shoppingCartCount) {
            this._cacheService.set('CreateOrderInfo', {
                distributorId: this.fboid, shoppingCart: this.shoppingCart,
                shoppingBagClicked: true,
                countryId: this.savedBagCountry
            });
        }
    }

    closeTabForParticularDistributor($event):void{
        let distributorId :string = $event;
        this.closeTabForFboID.emit(distributorId);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/fbodetail.component.ts